import { createFileRoute } from "@tanstack/react-router";

import { useMe } from "../features/auth/session";
import { AutopilotSettings } from "../features/autopilot/AutopilotSettings";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/settings/autopilot")({
  component: AutopilotSettingsRoute,
});

function AutopilotSettingsRoute() {
  const t = useT();
  const me = useMe();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return (
    <>
      <h2>{t("settings.autopilot.title")}</h2>
      <AutopilotSettings key={me.data.activeOrganizationId ?? "none"} me={me.data} />
    </>
  );
}
